import React, { useEffect, memo } from 'react';
import { updateWidgetProps } from '@components/common/EmpWidget/EMPWidgetContainer';
import { ModalProps } from 'antd';
import { MutateOptions } from 'react-query';

interface EmpGenericMetricModalProps extends ModalProps {
  activateMutateOptions?: MutateOptions;
  mapEventMutateOptions?: MutateOptions;
}

const EmpGenericMetricModal: React.FC<EmpGenericMetricModalProps> = ({
  activateMutateOptions,
  mapEventMutateOptions,
  ...modalProps
}) => {
  useEffect(() => {
    updateWidgetProps({
      widgetName: 'GenericMetricModal',
      activateMutateOptions,
      mapEventMutateOptions,
      modalProps: {
        width: '1100px',
        style: { top: '2em' },
        destroyOnClose: true,
        ...modalProps,
      },
    });
  }, [modalProps, mapEventMutateOptions, activateMutateOptions]);
  return null;
};

export default memo(EmpGenericMetricModal, (pre, next) => pre.open === next.open);
